import locale from "localization/en";
import styles from "../dry-stock.module.scss";
import { Title } from "components/commons";
import useDataTable from "hooks/useDataTable";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { filter } from "lodash";
import { lubricantSalesMapper } from "./lubricant-sales.mapper";
import { lubricantSalesColumn } from "./lubricant-sales-column";
import Big from "big.js";

const LubricantSales = ({ shift, allProducts }) => {
  const isLubricant = true;
  const lubricants = filter(shift?.transactionItem.nonFuel, { type: "lubricant" });

  const products = new Map(allProducts.map((p) => [p.sku, p]));

  const formattedList = lubricants
    .map((lubricant) => {
      const product = products.get(lubricant.sku);

      let vatExemptAmount = lubricant.vatExempt12percent;
      let totalDiscount =
        Number(
          Big(lubricant.originalTotalAmount)
            .minus(lubricant.netTotalAmount)
            .minus(Math.abs(lubricant.vatExempt12percent))
            .mul(-1)
            .round(2),
        ) + vatExemptAmount;
      const finalAmount = lubricant.originalTotalAmount + totalDiscount + vatExemptAmount;

      return {
        ...lubricant,
        totalDiscount,
        finalAmount,
        category: product?.category?.name || "-",
        vatExemptAmount,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  const { table } = useDataTable({
    value: formattedList,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "nonFuel",
      name: "dryStockSales",
      mapper: (val) => lubricantSalesMapper({ val, isLubricant }),
      columns: lubricantSalesColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.lubricantSales}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default LubricantSales;
